import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, Loading } from '../Library'
import { viewRental, RentalStatus, setStatus } from '../Network/Rental'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle, faCheckCircle, faClock, faTimesCircle, faExclamationCircle, faBan } from '@fortawesome/free-solid-svg-icons'
import "./RentalDetail.css"
import { AlertModalContext } from '../Library/AlertModalContext'

function RentalDetail() {
  const langCx = useContext(LanguageContext)
  const lang = langCx.lang.tenant
  const alertModal = useContext(AlertModalContext)
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [detail, setDetail] = useState({})


  const fetchData = () => {
    setIsLoading(true)
    viewRental(id)
    .then((data) => {
      setDetail(data)
      setIsLoading(false)
    })
    .catch((error) => {
      setIsLoading(false)
    })
  }

  useEffect(() => {
    fetchData()
  },[])

  const startRental = () => {
    alertModal.setTitle(lang.start_rental)
    alertModal.setDescription(lang.start_rental_desc)
    alertModal.setIsShow(true)
    alertModal.setAlertType("WARNING")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "primary",
                onClick: ()=>{ 
                  setStatus(detail.id, RentalStatus.ACTIVE)
                  .then(() => { 
                    fetchData()
                    alertModal.setIsShow(false)
                  }).catch(()=>{})
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
  }

  const pauseRental = () => {
    alertModal.setTitle(lang.pause_rental)
    alertModal.setDescription(lang.pause_rental_desc)
    alertModal.setIsShow(true)
    alertModal.setAlertType("WARNING")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "primary",
                onClick: ()=>{ 
                  setStatus(detail.id, RentalStatus.IN_ACTIVE)
                  .then(() => { 
                    fetchData()
                    alertModal.setIsShow(false)
                  }).catch(()=>{})
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
  }

  const cancelRental = () => {
    alertModal.setTitle(lang.cancel_rental)
    alertModal.setDescription(lang.cancel_rental_desc)
    alertModal.setIsShow(true)
    alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                  setStatus(detail.id, RentalStatus.CANCELLED)
                  .then(() => { 
                    fetchData()
                    alertModal.setIsShow(false)
                  }).catch(()=>{})
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
  }

  return (
    <div id='rental-detail'>
      { isLoading &&
      <Loading/>
      }
      <HeaderTitle title={detail.location} backTo={'/rental'} isShowBack/>
      <Row>
        <Col lg={6}>
          <DetailRow title={lang.tenant_area} value={detail.location}/>
          <DetailRow title={lang.contract_no} value={detail.contractNo}/>
          <DetailRow title={lang.telephone} value={detail.telephone}/>
          <DetailRow title={lang.detail} value={detail.detail}/>
          <DetailRow title={lang.rental_start_date} value={dayjs(detail.startLeaseDate).format('D MMMM YYYY')}/>
          <DetailRow title={lang.expired_lease} value={dayjs(detail.expiredDate).format('D MMMM YYYY')}/>
          <DetailRow title={lang.request_by} value={detail.createLeaseBy}/>
          <DetailRow title={lang.created_at} value={dayjs(detail.createdDate).format('D MMMM YYYY')}/>
          <DetailRow title={lang.status} value={<StatusValue status={detail.status}/>}/>
          {/* <div className='tenant-list'>
            <div>
              <b>{lang.tenant}</b>
            </div>
            <div>{lang.tenant_desc}</div>
          </div> */}
        </Col>
        <Col lg={6}>
          { detail.status === RentalStatus.WAITING || detail.status === RentalStatus.IN_ACTIVE ?
          <ActionButton 
          title={lang.start_usage} 
          description={lang.start_usage_desc} 
          buttonVariant={"success"}
          buttonName={lang.start_usage}
          onClick={()=>startRental()}/>
          : null
          }
          { detail.status === RentalStatus.ACTIVE ?
          <ActionButton 
          title={lang.pause_usage} 
          description={lang.pause_usage_desc} 
          buttonVariant={"warning"}
          buttonName={lang.pause_usage}
          onClick={()=>pauseRental()}/>
          : null
          }
          { detail.status !== RentalStatus.CANCELLED ?
          <ActionButton 
          title={lang.cancel_contract} 
          description={lang.cancel_contract_desc} 
          buttonVariant={"danger"}
          buttonName={lang.cancel_contract}
          onClick={()=>cancelRental()}
          />
          : null
          }
        </Col>
      </Row>
    </div>
  )
}

function ActionButton({ title, description, buttonName, buttonVariant, onClick }){
  return(
    <div className='action-button'>
      <div>
        <b>{title}</b>
      </div>
      <div>
        {description}
      </div>
      <div className='click-button-container'>
        <Button 
        className='click-button'
        variant={buttonVariant} 
        onClick={onClick}>
          {buttonName}
        </Button>
      </div>
    </div>
  )
}

function StatusValue({ status }){
  const langCx = useContext(LanguageContext)
  const lang = langCx.lang.tenant
  let statusIcon = { icon: faQuestionCircle, color: 'grey', text: lang.no_status }

  switch(status){
    case(RentalStatus.ACTIVE):
      statusIcon = { icon: faCheckCircle, color: 'green', text: lang.active }
      break
    case(RentalStatus.IN_ACTIVE):
      statusIcon = { icon: faBan, color: 'grey', text: lang.in_active }
      break
    case(RentalStatus.WAITING):
      statusIcon = { icon: faClock, color: 'orange', text: lang.waiting }
      break
    case(RentalStatus.CANCELLED):
      statusIcon = { icon: faTimesCircle, color: 'red', text: lang.cancelled }
      break
    case(RentalStatus.OVERDUE):
      statusIcon = { icon: faExclamationCircle, color: 'red', text: lang.overdue }
      break
    case(RentalStatus.DISABLE):
      statusIcon = { icon: faBan, color: 'red', text: lang.disable }
      break
    case(RentalStatus.EXPIRED):
      statusIcon = { icon: faExclamationCircle, color: 'red', text: lang.expired }
      break
    case(RentalStatus.EXPIRE_SOON):
      statusIcon = { icon: faExclamationCircle, color: 'orange', text: lang.expire_soon }
      break
  }

  return(
    <div>
      <FontAwesomeIcon icon={statusIcon.icon} color={statusIcon.color}/>
      <span style={{ marginLeft: 10 }}>{statusIcon.text}</span>
    </div>
  )
}

function DetailRow({ title, value }){
  return (
    <div className='detail-row'>
      <div className='title-col'>
        <b>{title} :</b>
      </div>
      <div className='value-col'>{value}</div>
    </div>
  )
}

export default RentalDetail